import { trackingPixelPath, domain } from "@rezonence/analytics";

export const trackingEndpoint = `https://${domain}${trackingPixelPath}`;
